import React, { FC } from 'react'
import { twMerge } from 'tailwind-merge'

import { Box } from '../box'
import { Text } from '../text'

export type BadgeTowingListProps = {
    /** Short code shown in the badge, e.g. `S`. */
    content: string
    className?: string
    testID?: string
}

/**
 * Compact status badge used in the towing list (Figma node 10350:69862): a 16px
 * tall, 4px-radius `graphics/blue` pill with a P3 semibold code in the inverted
 * (dark-on-light) ink. (AOS-631)
 */
export const BadgeTowingList: FC<BadgeTowingListProps> = ({ content, className, testID }) => (
    <Box
        className={twMerge(
            'h-4 min-w-6 items-center justify-center rounded bg-graphics-blue px-2',
            className,
        )}
        testID={testID}
    >
        <Text size='caption' weight='bold' tone='on-graphics'>
            {content}
        </Text>
    </Box>
)

BadgeTowingList.displayName = 'BadgeTowingList'
